function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScratch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419.2 279.6",
    style: {
      enableBackground: "new 0 0 419.2 279.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M371.5,12.8H48.1c-15.9,0-28.9,12.8-28.9,28.8v19.8h0.2v176.7c0,16,12.8,28.8,28.8,28.8h323 c16,0,28.8-12.7,28.8-28.8V41.6C400,25.6,387.4,12.8,371.5,12.8z M111.1,158.2c0,3.5-2.9,6.4-6.4,6.4H36.7c-3.5,0-6.4-2.9-6.4-6.4 v-4.5c0-3.5,2.9-6.4,6.4-6.4h68.1c3.5,0,6.4,2.9,6.4,6.4V158.2z M111.1,120.2c0,3.5-2.9,6.4-6.4,6.4H36.7c-3.5,0-6.4-2.9-6.4-6.4 v-4.5c0-3.5,2.9-6.4,6.4-6.4h68.1c3.5,0,6.4,2.9,6.4,6.4V120.2z M202.8,120.2c0,3.5-2.9,6.4-6.4,6.4h-68.1c-3.5,0-6.4-2.9-6.4-6.4 v-4.5c0-3.5,2.9-6.4,6.4-6.4h68.1c3.5,0,6.4,2.9,6.4,6.4V120.2z M293.3,120.2c0,3.5-2.9,6.4-6.4,6.4h-68.1c-3.5,0-6.4-2.9-6.4-6.4 v-4.5c0-3.5,2.9-6.4,6.4-6.4h68.1c3.5,0,6.4,2.9,6.4,6.4V120.2z M383.7,120.2c0,3.5-2.9,6.4-6.4,6.4h-68.1c-3.5,0-6.4-2.9-6.4-6.4 v-4.5c0-3.5,2.9-6.4,6.4-6.4h68.1c3.5,0,6.4,2.9,6.4,6.4V120.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScratch);
export default __webpack_public_path__ + "static/media/scratch.938ce3382c45b333562657c1c26d0a61.svg";
export { ForwardRef as ReactComponent };